// extracted by mini-css-extract-plugin
export var activeTab = "tabbed-content-underline-module--activeTab--dbcb5";
export var tabContainer = "tabbed-content-underline-module--tabContainer--b2f90";
export var tabIndicator = "tabbed-content-underline-module--tabIndicator--474d3";
export var underlineTab = "tabbed-content-underline-module--underlineTab--b042d";
export var underlineTabs = "tabbed-content-underline-module--underlineTabs--7a2c7";